<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-8 col-lg-8">
            <h4>
              <i class="fa fa-hand-pointer-o" aria-hidden="true" style="font-size: 21px; margin-right: 10px; color: var(--iq-primary);"></i>
              {{ cvCardTitle }}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="SpcmCalendarCategoryAdd">{{cvbtnAddNew}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col lg="8">
            <b-row>
              <!-- Frontend Search -->
              <!--
              <b-col sm="4" md="4" lg="4" xl="4" class="mb-3">
                <b-form-input
                  id="search"
                  v-model="filter"
                  type="search"
                  :placeholder="cvSearchText"
                ></b-form-input>
              </b-col>
              -->
              <!-- Frontend Search -->

              <!-- Backend Search -->
               <b-col class="col-12 mb-3">
                <b-form-input class="form-control"
                  @input="searchSpcmCalendarCategoryWithParams"
                  v-model="search_param"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>
              </b-col><!-- Backend Search -->

            </b-row>
          </b-col>
          <b-col class="mb-2 col-12 col-lg-4 date_csv">
            <div class="dateRange">
              <i class="fa-solid fa-filter-circle-xmark Download_button" title="Remove all filter" @click="removeAllFilter"></i>
              <i v-if="spcm_calendar_categoryObjList && spcm_calendar_categoryObjList.length > 0" :csv-title="csvTitle" class="fa-solid fa-file-csv Download_button" title="Download CSV" @click="backendCsvDownload"></i>
              <date-range-picker class="float-right" ref="picker" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"  v-model="whereFilter.dateRange"  @update="getSpcmCalendarCategoryDateWise()" ></date-range-picker>
            </div>
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="spcm_calendar_categoryObjList && spcm_calendar_categoryObjList.length > 0" :key="currentBatchNo">
            <b-table
              hover
              responsive
              :items="spcm_calendar_categoryObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
              <template v-slot:cell(created_on)="data">
                {{data.item.created_on | dateFormat}}
              </template>
              <template v-slot:cell(action)="data">
                <b-button class="ml-2 actionIcon" @click="SpcmCalendarCategoryEdit(data.item)" v-if="!data.item.editable"><i class="ri-ball-pen-fill m-0 font-size-20"></i></b-button>
                <b-button class="ml-2 actionIcon" @click="showSpcmCalendarCategoryDeleteDialog(data.item)" ><i class="ri-delete-bin-line m-0 font-size-20"></i></b-button>
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
          <b-col sm="12" md="7">
            <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
          </b-col>
          <b-col sm="5" md="5">
            <b-pagination
              v-model="currentBatchNo"
              :total-rows="totalRows"
              :per-page="dataPerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
         </div>
      </b-col>
    </b-row>

    <b-modal v-model="showModelSpcmCalendarCategoryAdd" scrollable :title="cvAddModalHeader">
      <SpcmCalendarCategoryAdd :propOpenedInModal="true" @emitCloseSpcmCalendarCategoryAddModal="closeSpcmCalendarCategoryAddModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeSpcmCalendarCategoryAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelSpcmCalendarCategoryEdit" scrollable :title="cvEditModalHeader">
      <SpcmCalendarCategoryEdit :propOpenedInModal="true" :propSpcmCalendarCategoryObj="spcm_calendar_categoryEditObj" @emitCloseSpcmCalendarCategoryEditModal="closeSpcmCalendarCategoryEditModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeSpcmCalendarCategoryEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelSpcmCalendarCategoryDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelSpcmCalendarCategoryDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="SpcmCalendarCategoryDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { SpcmCalendarCategorys } from "../../../FackApi/api/SpcmCalendarCategory.js"
import SpcmCalendarCategoryAdd from "./SpcmCalendarCategoryAdd.vue"
import SpcmCalendarCategoryEdit from "./SpcmCalendarCategoryEdit.vue"
import moment from "moment"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"

export default {
  name: "SpcmCalendarCategoryList",
  components: {
    SpcmCalendarCategoryAdd,
    SpcmCalendarCategoryEdit
  },
  data () {
    return {
      cvCardTitle: "Spcm Calendar Category",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit SpcmCalendarCategory",
      cvAddModalHeader: "Add SpcmCalendarCategory",
      cvbtnModalCancel: "Cancel",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "SpcmCalendarCategory",
      showModelSpcmCalendarCategoryAdd: false,
      showModelSpcmCalendarCategoryEdit: false,
      showModelSpcmCalendarCategoryDelete: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "#", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Category Name", key: "category_name", class: "text-left align-text-top", sortable: true },
        { label: "Description", key: "description", class: "text-left align-text-top", sortable: true },
        { label: "Color Code", key: "color_code", class: "text-left align-text-top", sortable: true },
        { label: "Spcm Session Allow", key: "spcm_session_allow", class: "text-left align-text-top", sortable: true },
        { label: "Created On", key: "created_on", class: "text-left align-text-top", sortable: true },
        { label: "Action", key: "action", class: "text-left align-text-top", sortable: false }
      ],
      spcm_calendar_categoryObjList: [],
      spcm_calendar_categoryEditObj: null,
      spcm_calendar_categoryFiltersList: [],
      filter: null,
      csvTitle: "SpcmCalendarCategory",
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      delObj: null,
      whereFilter: {
        dateRange: {
          startDate: new Date(new Date().setDate(new Date().getDate() - 365)), // From Last Year
          endDate: new Date(new Date().setDate(new Date().getDate() + 1))
        }

      },
      search_param: "",
      currentBatchNo: 1,
      dataPerPage: 25,
      showLoadMoreBtn: true
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    dateFilter () {
      return { ...this.$store.getters["DateFilter/selectedDateState"] }
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    await this.getDateFilter()

    this.SpcmCalendarCategoryList()
  },
  methods: {
    /**
     * set Filters
     */
    async setFilters () {
      this.SpcmCalendarCategoryList()
    },
    /**
     * Get daterange from LS. If found then use this as default else use the onse set in the data section of the object
     */
    async getDateFilter () {
      let storeDate = await this.dateFilter
      if (storeDate && storeDate.dateRange) {
        this.whereFilter = storeDate
      }
    },
    /**
     * search SpcmCalendarCategoryWithParams
     */
    async searchSpcmCalendarCategoryWithParams () {
      if (this.whereFilter.search_param.length <= 3) {
        return
      }
      this.currentBatchNo = 1
      this.SpcmCalendarCategoryList()
    },
    /**
     * load More Data
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.SpcmCalendarCategoryList(true)
    },
    /**
     * Calling Function as per whereFilter
     */
    async getSpcmCalendarCategoryDateWise () {
      this.SpcmCalendarCategoryList()
      await this.setDateFilter()
    },
    /**
     * Setting Date Range in the LS
     */
    async setDateFilter () {
      let endDate = this.whereFilter.dateRange.endDate
      this.whereFilter.dateRange.endDate = new Date(new Date(endDate).setDate(new Date(endDate).getDate() + 1))
      let whereDateFilter = { dateRange: this.whereFilter.dateRange }
      await this.$store.commit("DateFilter/addSelectedDate", whereDateFilter)
    },
    /**
     * backend Csv Download
     */
    async backendCsvDownload () {
      this.SpcmCalendarCategoryList(false, true)
    },
    /**
     * SpcmCalendarCategory List
     */
    async SpcmCalendarCategoryList (loadViaLoadMore = false, downloadCsv = false) {
      try {
        // setting data for pagination
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.search_param = this.search_param
        this.whereFilter.downloadCsv = downloadCsv

        let SpcmCalendarCategoryListResp = await SpcmCalendarCategorys.SpcmCalendarCategoryList(this, this.whereFilter)
        if (SpcmCalendarCategoryListResp.resp_status) {
          if (downloadCsv) {
            window.open(SpcmCalendarCategoryListResp.resp_csv_file_url)
            return
          }

          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.spcm_calendar_categoryObjList = [ ...SpcmCalendarCategoryListResp.resp_data.data ]
          }
          else {
            this.spcm_calendar_categoryObjList = [ ...this.spcm_calendar_categoryObjList, ...SpcmCalendarCategoryListResp.resp_data.data ]
          }
          this.showLoadMoreBtn = true

          // Adding the serial numbers:
          this.spcm_calendar_categoryObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.spcm_calendar_categoryObjList.length
        }
        else {
          this.currentBatchNo = this.currentBatchNo == 1 ? 1 : (this.currentBatchNo - 1)
          this.showLoadMoreBtn = false
          this.toastMsg = SpcmCalendarCategoryListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at SpcmCalendarCategoryList() and Exception:", err)
      }
    },
    /**
     * SpcmCalendarCategoryAdd
     */
    SpcmCalendarCategoryAdd (type) {
      try {
        this.showModelSpcmCalendarCategoryAdd = true
      }
      catch (err) {
        console.error("Exception occurred at SpcmCalendarCategoryAdd() and Exception:", err.message)
      }
    },
    /**
     * SpcmCalendarCategory Edit
     */
    SpcmCalendarCategoryEdit (item) {
      try {
        this.spcm_calendar_categoryEditObj = item
        this.showModelSpcmCalendarCategoryEdit = true
      }
      catch (err) {
        console.error("Exception occurred at SpcmCalendarCategoryEdit() and Exception:", err.message)
      }
    },
    /**
     * showSpcmCalendarCategory DeleteDialog
     */
    showSpcmCalendarCategoryDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelSpcmCalendarCategoryDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showSpcmCalendarCategoryDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * SpcmCalendarCategory Delete
     */
    async SpcmCalendarCategoryDelete () {
      try {
        let SpcmCalendarCategoryDelResp = await SpcmCalendarCategorys.SpcmCalendarCategoryDelete(this, this.delObj.spcm_calendar_category_id)
        await ApiResponse.responseMessageDisplay(this, SpcmCalendarCategoryDelResp)

        if (SpcmCalendarCategoryDelResp && !SpcmCalendarCategoryDelResp) {
          this.showModelSpcmCalendarCategoryDelete = false
          return false
        }

        let index = this.spcm_calendar_categoryObjList.indexOf(this.delObj)
        this.spcm_calendar_categoryObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelSpcmCalendarCategoryDelete = false
      }
      catch (err) {
        console.error("Exception occurred at SpcmCalendarCategoryDelete() and Exception:", err.message)
      }
    },
    /**
     * closeSpcmCalendarCategory AddModal
     */
    closeSpcmCalendarCategoryAddModal (SpcmCalendarCategoryAddData) {
      try {
        if (SpcmCalendarCategoryAddData) {
          if (this.spcm_calendar_categoryObjList && this.spcm_calendar_categoryObjList.length >= 1) {
            let SpcmCalendarCategoryObjLength = this.spcm_calendar_categoryObjList.length
            let lastId = this.spcm_calendar_categoryObjList[SpcmCalendarCategoryObjLength - 1]["id"]
            SpcmCalendarCategoryAddData.id = lastId + 1
          }
          else {
            this.spcm_calendar_categoryObjList = []
            SpcmCalendarCategoryAddData.id = 11111
          }

          SpcmCalendarCategoryAddData.created_on = moment()
          this.spcm_calendar_categoryObjList.unshift(SpcmCalendarCategoryAddData)
          this.totalRows = this.totalRows + 1
        }

        this.showModelSpcmCalendarCategoryAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closeSpcmCalendarCategoryAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeSpcmCalendarCategory EditModal
     */
    closeSpcmCalendarCategoryEditModal () {
      try {
        this.showModelSpcmCalendarCategoryEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closeSpcmCalendarCategoryEditModal() and Exception:", err.message)
      }
    },
    /*
     * SpcmCalendarCategory FilterList
     */
    async SpcmCalendarCategoryFilterList (filterName = null) {
      if (!filterName) {
        return
      }
      try {
        let SpcmCalendarCategoryFilterListResp = await SpcmCalendarCategorys.SpcmCalendarCategoryFilterList(this, filterName)
        if (SpcmCalendarCategoryFilterListResp) {
          this.spcm_calendar_categoryFiltersList[filterName] = SpcmCalendarCategoryFilterListResp.resp_data
        }
      }
      catch (err) {
        console.error("Exception occurred at SpcmCalendarCategory_filter_list_resp() and Exception:", err.message)
      }
    },
    /**
     * remove All Filter
     */
    removeAllFilter () {
      this.whereFilter = {
        // value should be null
      }
      this.SpcmCalendarCategoryList(false, false)
    }
  }
}
</script>
